import React from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Label
} from "reactstrap";
import { pageActions } from "../../../../../store/actions/cms/page/page.action";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { deepClone } from "../../../../../helpers/objectHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ArchiveContainer from "../../../../../file/containers/ArchiveContainer";
import { content } from "../../../../models/content";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { templateHelper } from "../../../../areas/template/helpers/templateHelper";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { UrlMultiInput } from "../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import Select from 'react-select';


const imageShapes = [
  { value: 'ORIGINAL', label: <SystemLabel name='Original' /> },
  { value: 'CIRCLE', label: <SystemLabel name='Circle' /> },
  { value: 'SQUARE', label: <SystemLabel name='Square' /> },
  { value: 'FULL', label: <SystemLabel name='FullWidth' /> }
]

class ImageSettings extends React.Component {
  state = {
    isMediaVaultOpen: false
  };
  handleSoftUpdate = element => {
    const { dispatch, enviroment, page } = this.props;
    if (enviroment === sourceTypes.FORM)
      dispatch(formActions.updateFormElement(element));
    if (enviroment === sourceTypes.PAGE)
      dispatch(pageActions.updatePageElement(element, null, page));
    if (enviroment === sourceTypes.TEMPLATE) {
      const template = deepClone(this.props.template);
      const newTemplate = templateHelper.handleElementUpdates(
        element,
        template
      );
      dispatch(templateActions.softUpdate(newTemplate));
    }
  };
  setAttribute = (attr, path) => {
    const { selectedElement } = this.props;
    const names = path.split(".");
    let element = deepClone(selectedElement);

    if (path === "data.style") {
      const defSettings = content.find(el => {
        return el.settings.type === element.data.type;
      });
      element.data.style = deepClone(defSettings.settings.style);
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = attr;
    } else {
      element[names[0]][names[1]] = attr;
    }
    this.handleSoftUpdate(element);
  };
  handleSlider(e, path) {
    const names = path.split(".");
    const selectedElement = deepClone(this.props.selectedElement);

    if (path === "data.style.width") {
      selectedElement[names[0]][names[1]][names[2]] = e + "%";
    } else if (path === "data.titleWidth") {
      selectedElement.data.inputWidth = 100 - e;
      selectedElement[names[0]][names[1]] = e /* + '%' */;
    } else if (path === "data.inputWidth") {
      selectedElement.data.titleWidth = 100 - e;
      selectedElement[names[0]][names[1]] = e /* + '%' */;
    }
    this.handleSoftUpdate(selectedElement);
  }
  toggle = (tabPane, tab) => {
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    this.setState({
      activeTab: newArray
    });
  };
  handleChange = (e, val, path) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    let value = null;
    if (val && val.hex !== undefined) {
      const { r, g, b, a } = val.rgb;
      value = `rgba(${r},${g},${b},${a})`;
    } else if (val) value = val;
    else if (e !== null) value = e.target.value;
    else return;

    if (element.data.type !== 'FULL' && element.data.type !== 'ORIGINAL' &&
      path === 'data.style.width') {

      element.data.style.width = value;
      element.data.style.height = value;
    }
    else if (element.data.type === 'ORIGINAL' && path === 'data.style.width') {
      if (element.data.orgSize) {
        element.data.style.width = value;
        let heightRatio = (element.data.orgSize.height / element.data.orgSize.width)
        element.data.style.height = value * heightRatio;
      }
    }
    else if (element.data.type === 'ORIGINAL' && path === 'data.style.height') {
      if (element.data.orgSize) {
        element.data.style.height = value;
        let widthRatio = (element.data.orgSize.width / element.data.orgSize.height)
        element.data.style.width = value * widthRatio;
      }
    }
    else if (path === 'data.type' && val === 'ORIGINAL') {
      if (element.data.orgSize) {
        element.data.style.height = element.data.orgSize.height;
        element.data.style.width = element.data.orgSize.width;
      }
      element.data.type = value;
    }
    else if (path === 'data.type' && (val === 'CIRCLE' || val === 'SQUARE')) {
      element.data.style.height = '210px';
      element.data.style.width = '210px';
      element.data.type = value;
    }
    else if (names.length === 2) {
      element[names[0]][names[1]] = value;
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = value;
    } else if (names.length === 4) {
      element[names[0]][names[1]][names[2]][names[3]] = value;
    }
    this.handleSoftUpdate(element);
  }
  expandArea = area => {
    this.setState({ [area]: !this.state[area] });
  };
  toggleMediaVault = () => {
    this.setState({ isMediaVaultOpen: !this.state.isMediaVaultOpen });
  };
  setImage = url => {
    const element = deepClone(this.props.selectedElement);
    element.props.value = url;
    this.handleSoftUpdate(element);
  };
  render() {
    const { selectedElement } = this.props;
    return (
      <div>
        <ListExpansion
          footer={false}
          icon="fa fa-image"
          description="ImageSettings"
          defaultExpanded={true}
        >
          {selectedElement.data.type !== "FULL" && selectedElement.data.type !== "ORIGINAL" ? (
            <React.Fragment>
              <EditorSlider
                value={selectedElement.data.style.width !== undefined &&
                  selectedElement.data.style.width !== "unset"
                  ? parseFloat(selectedElement.data.style.width)
                  : 0}
                defaultValue={0}
                unitChange={() => null}
                onChange={this.handleChange}
                units={["px"]}
                activeUnit={'px'}
                steps={1}
                attachUnit={true}
                max={320}
                min={1}
                path={'data.style.width'}
                label="ImgSize"
              />
              <hr />
            </React.Fragment>
          ) : null}
          {selectedElement.data.type === "ORIGINAL" ? <React.Fragment>
            <EditorSlider
              value={selectedElement.data.style.height !== undefined &&
                selectedElement.data.style.height !== "unset"
                ? parseFloat(selectedElement.data.style.height)
                : 0}
              defaultValue={selectedElement.data.orgSize ? selectedElement.data.orgSize.height : 0}
              unitChange={() => null}
              onChange={this.handleChange}
              units={["px"]}
              activeUnit={'px'}
              steps={1}
              max={1800}
              min={1}
              path={'data.style.height'}
              label="ImgHeight"
            />
            <hr />
            <EditorSlider
              value={selectedElement.data.style.width !== undefined &&
                selectedElement.data.style.width !== "unset"
                ? parseFloat(selectedElement.data.style.width)
                : 0}
              defaultValue={selectedElement.data.orgSize ? selectedElement.data.orgSize.height : 0}
              unitChange={() => null}
              onChange={this.handleChange}
              units={["px"]}
              activeUnit={'px'}
              steps={1}
              max={1000}
              min={1}
              path={'data.style.width'}
              label="ImgWidth"
            />
            <hr />
          </React.Fragment> : null}

          {selectedElement.data.type === "FULL" ? <React.Fragment>
            <EditorSlider
              value={selectedElement.data.style.maxHeight !== undefined &&
                selectedElement.data.style.maxHeight !== "unset"
                ? parseFloat(selectedElement.data.style.maxHeight)
                : 0}
              defaultValue={0}
              unitChange={() => null}
              onChange={this.handleChange}
              units={["px"]}
              activeUnit={'px'}
              steps={1}
              max={1000}
              min={1}
              path={'data.style.maxHeight'}
              label="MaxHeight"
            />
            <hr />
          </React.Fragment> : null}
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="ImageShape" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              <Select
                classNamePrefix="jirango-select"
                className="jirango-select"
                options={imageShapes.map(t => {
                  return { value: t.value, label: t.label };
                })}
                value={imageShapes.find(t => {
                  return t.value === selectedElement.data.type;
                })}
                onChange={selectedOption =>
                  this.handleChange(
                    null,
                    selectedOption.value,
                    "data.type"
                  )
                }
              />
            </Col>
          </Row>
          <hr />
          <AlignmentButtonGroup
            onChange={this.handleChange}
            alignment={selectedElement.data.alignment}
            path="data.alignment"
            type={["left", 'center', 'right']}
          />
          <hr />
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="ImageSrc" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              {this.state.isMediaVaultOpen && (
                <ArchiveContainer
                  toggle={this.toggleMediaVault}
                  typeRequest="img"
                  onUseSelected={this.setImage}
                  showLaunchBtn={false}
                  isOpen={this.state.isMediaVaultOpen}
                />
              )}
            </Col>
          </Row>

          <UrlMultiInput setImage={this.setImage} margin={false} onChange={this.handleChange} path={'props.value'} url={selectedElement.props.value} />
          <hr />
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="ActionLink" />
              </Label>
            </Col>
          </Row>
          <UrlMultiInput
            margin={false} externalSourceOnly={true}
            linkHelper={true}
            path={'data.actionLink'}
            onChange={this.handleChange}
            url={selectedElement.data.actionLink} />
        </ListExpansion>
      </div >
    );
  }
}
function mapStateToProps(state) {
  const { enviroment } = state.cms;
  let selectedElement = null;
  if (enviroment === sourceTypes.FORM)
    selectedElement = state.form.selectedElement;
  if (enviroment === sourceTypes.PAGE)
    selectedElement = state.page.selectedElement;
  if (enviroment === sourceTypes.TEMPLATE)
    selectedElement = state.template.selectedElement;
  return {
    enviroment: enviroment,
    template: state.template.template,
    form: state.form,
    page: state.page,
    selectedElement: selectedElement
  };
}
export default connect(mapStateToProps)(ImageSettings);
